import { Context } from '../..';
import * as base from '../base';
import { CareerPath } from '../../../models/view/career-path';
import { ErrorSignalTypes } from '../../../enums';
import { handleErrorToErrorPage } from '../functions';
import { AssessmentsWizardFieldsOfPractice } from '../../../pages/assessment-management/fop/assessment-fop.widget';


const CONTROLLER = `careerpath`;
// @Jedidja
export async function getCareerPaths(context: Context): Promise<CareerPath[] | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = {
    url: base.apiURL(CONTROLLER, `assessment${base.params({
      assessmentSlug: context.state.activeAssessmentConfig?.assessmentSlug
    })}`), authenticated: true
  };
  const response: base.IResponse<CareerPath[]> = await base.request(request);

  return response.data;
}

export async function getCompanyCareerPaths(context: Context, companySlug: string): Promise<CareerPath[] | undefined> {
  const request: base.IRequest = { url: base.apiURL(`careerpath`, `platform${base.params({ companySlug: companySlug })}`), authenticated: true };
  const response: base.IResponse<CareerPath[]> = await base.request(request);

  return response.data;
}

export async function postAssessmentCareerPathSlugs(context: Context, payload: AssessmentsWizardFieldsOfPractice): Promise<string | undefined> {
  const url = base.apiURL(CONTROLLER);
  const request: base.IRequest = {
    url, method: 'POST', body: JSON.stringify({
      ...payload,
      companySlug: context.state.companyVariables.slug,
      assessmentSlug: payload.assessmentSlug
    })
  };
  const response: base.IResponse<string> = await base.request(request);
  return response.data;
}

export async function getAssessmentCareerPathSlugs(
  context: Context,
  assessmentSlug: string
): Promise<
  | {
    careerPathSlugs: string[];
  }
  | undefined
> {
  const url = base.apiURL(`${CONTROLLER}${base.params({
    companySlug: context.state.companyVariables.slug,
    assessmentSlug: assessmentSlug
  })}`);
  const response: base.IResponse<{ careerPathSlugs: string[] }> = await base.request({ url });
  return response.data;
}
